import { Code2, File, FileCode, FileImage, FileJson, FileText, FileType, Folder, NotebookPen } from 'lucide-react';
import { cn } from '@/lib/utils/cn';

const ICON_SIZE = 'size-4';

export function FolderIcon({ className }: { className?: string }) {
  return <Folder className={cn(ICON_SIZE, 'text-sky-500', className)} />;
}

export type FileKind = 'file' | 'directory' | 'notebook';

export function FileItemIcon({ name, kind, className }: { name: string; kind: FileKind; className?: string }) {
  if (kind === 'directory') {
    return <FolderIcon className={className} />;
  }
  if (kind === 'notebook') {
    return <NotebookPen className={cn(ICON_SIZE, 'text-orange-500', className)} />;
  }

  const ext = name.split('.').pop()?.toLowerCase() ?? '';
  switch (ext) {
    case 'ipynb':
      return <NotebookPen className={cn(ICON_SIZE, 'text-orange-500', className)} />;
    case 'py':
    case 'pyi':
      return <FileCode className={cn(ICON_SIZE, 'text-yellow-500', className)} />;
    case 'js':
    case 'jsx':
    case 'ts':
    case 'tsx':
    case 'mjs':
    case 'cjs':
      return <Code2 className={cn(ICON_SIZE, 'text-sky-500', className)} />;
    case 'json':
    case 'jsonl':
      return <FileJson className={cn(ICON_SIZE, 'text-green-500', className)} />;
    case 'yaml':
    case 'yml':
    case 'toml':
    case 'ini':
    case 'cfg':
    case 'conf':
      return <FileType className={cn(ICON_SIZE, 'text-purple-500', className)} />;
    case 'md':
    case 'mdx':
    case 'txt':
    case 'rst':
      return <FileText className={cn(ICON_SIZE, 'text-gray-500', className)} />;
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'webp':
    case 'svg':
    case 'pdf':
      return <FileImage className={cn(ICON_SIZE, 'text-fuchsia-500', className)} />;
    case 'html':
    case 'htm':
    case 'css':
    case 'xml':
      return <Code2 className={cn(ICON_SIZE, 'text-pink-500', className)} />;
    default:
      return <File className={cn(ICON_SIZE, 'text-gray-400', className)} />;
  }
}
